module.exports = __webpack_public_path__ + "static/media/specific-risk-risky-dna.e742dc7a.svg";